export enum VodStatus {
  NONE = 'none',
  READY = 'ready'
}
